import {
  checkEmpty, checkNumerical, checkUuid, checkEmail, checkIp, checkDeviceTypeInRange, checkBrandFamilyInRange, checkPreferenceTypeInRange,
  checkCapacityTariffTypeInRange, checkEnergyTariffTypeInRange, checkLatitude, checkLongitude, checkIsPositiveInt,
  checkIsValidNumber, checkOrientationTypeInRange, checkIsValidNumberInRange0_100, checkIsValidNumberInRange0_360, checkIsValidNumberInRangeMinus90_90, checkIsBoolean,
  checkLanguageCodeInRange
} from "./fieldValidator";

function composeValidators(validators) {
  return function (value) {
    for (var i = 0; i < validators.length; i++) {
      var error = validators[i](value);
      if (error) {
        return error;
      }
    }
    return null;
  };
}

const validatorRegistry = {
  display_name: composeValidators([checkEmpty, checkNumerical]),
  customer_reference: composeValidators([checkIsValidNumber]),
  idp_id: checkEmpty,
  customer_id: composeValidators([checkEmpty, checkUuid]),
  site_id: composeValidators([checkEmpty, checkUuid]),
  email: composeValidators([checkEmpty, checkEmail]),
  postal_address: composeValidators([checkEmpty, checkNumerical]),
  latitude: composeValidators([checkEmpty, checkLatitude]),
  longitude: composeValidators([checkEmpty, checkLongitude]),
  model: composeValidators([checkEmpty, checkNumerical]),
  serial_nr: composeValidators([checkEmpty, checkNumerical]),
  local_ip: composeValidators([checkEmpty, checkIp]),
  device_type: composeValidators([checkDeviceTypeInRange]),
  brand_and_family: composeValidators([checkBrandFamilyInRange]),
  active_steering_mode: composeValidators([checkEmpty, checkUuid]),
  preference_type: composeValidators([checkPreferenceTypeInRange]),
  capacity_tariff_type: composeValidators([checkCapacityTariffTypeInRange]),
  energy_tariff_type: composeValidators([checkEnergyTariffTypeInRange]),
  system_operator: composeValidators([checkEmpty, checkNumerical]),
  capacity_price_param1: composeValidators([checkIsValidNumber]),
  capacity_price_param2: composeValidators([checkIsValidNumber]),
  energy_price_param1: composeValidators([checkIsValidNumber]),
  energy_price_param2: composeValidators([checkIsValidNumber]),
  ap_offtake_ean: composeValidators([checkEmpty, checkNumerical]),
  ap_injection_ean: composeValidators([checkEmpty, checkNumerical]),
  main_amount_of_phases: composeValidators([checkEmpty, checkIsPositiveInt]),
  has_grid_measurement: composeValidators([checkIsBoolean]),
  has_load_ac_main: composeValidators([checkIsBoolean]),
  has_pv_ac_main: composeValidators([checkIsBoolean]),
  has_bess: composeValidators([checkIsBoolean]),
  has_pv_dc: composeValidators([checkIsBoolean]),
  has_load_bess_acout1: composeValidators([checkIsBoolean]),
  has_pv_bess_acout1: composeValidators([checkIsBoolean]),
  has_load_bess_acout2: composeValidators([checkIsBoolean]),
  has_pv_bess_acout2: composeValidators([checkIsBoolean]),
  grid_measurement_source: composeValidators([checkEmpty, checkUuid]),
  load_ac_main_measurement_source: composeValidators([checkEmpty, checkUuid]),
  pv_ac_measurement_source: composeValidators([checkEmpty, checkUuid]),
  bess_measurement_source: composeValidators([checkEmpty, checkUuid]),
  pv_dc_measurement_source: composeValidators([checkEmpty, checkUuid]),
  load_bess_acout1_measurement_source: composeValidators([checkEmpty, checkUuid]),
  pv_bess_acout1_measurement_source: composeValidators([checkEmpty, checkUuid]),
  load_bess_acout2_measurement_source: composeValidators([checkEmpty, checkUuid]),
  pv_bess_acout2_measurement_source: composeValidators([checkEmpty, checkUuid]),
  pv_ac_main_nominal_power: composeValidators([checkIsValidNumber]),
  pv_ac_main_orientation: composeValidators([checkOrientationTypeInRange]),
  pv_dc_orientation: composeValidators([checkOrientationTypeInRange]),
  pv_bess_acout1_orientation: composeValidators([checkOrientationTypeInRange]),
  pv_bess_acout2_orientation: composeValidators([checkOrientationTypeInRange]),
  bess_inverter_brand_and_model: composeValidators([checkEmpty, checkNumerical]),
  bess_amount_of_inverters: composeValidators([checkEmpty, checkIsPositiveInt]),
  bess_nominal_capacity: composeValidators([checkIsValidNumber]),
  bess_max_charge_power: composeValidators([checkIsValidNumber]),
  bess_max_discharge_power: composeValidators([checkIsValidNumber]),
  bess_charge_efficiency: composeValidators([checkIsValidNumberInRange0_100]),
  bess_discharge_efficiency: composeValidators([checkIsValidNumberInRange0_100]),
  pv_dc_nominal_power: composeValidators([checkIsValidNumber]),
  pv_bess_acout1_nominal_power: composeValidators([checkIsValidNumber]),
  pv_bess_acout2_nominal_power: composeValidators([checkIsValidNumber]),
  has_pv: composeValidators([checkIsBoolean]),
  pv_azimuth: composeValidators([checkIsValidNumberInRange0_360]),
  pv_inclination: composeValidators([checkIsValidNumberInRangeMinus90_90]),
  language: composeValidators([checkLanguageCodeInRange])

  // ... other field validators
};

export default validatorRegistry;
